import React from "react";
import MateriasForm from "./MateriasForm";
import MateriaVideosManager from "./MateriaVideosManager";

const ModalWrapper = ({ open, title, children, onClose, size = "modal-lg" }) => {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default function MateriasFormModal({
  modal = "",
  formNuevo = {},
  setFormNuevo = () => {},
  formEditar = {},
  setFormEditar = () => {},
  savingNuevo = false,
  savingEditar = false,
  deleting = false,
  materiaSeleccionada = null,
  cerrarModal = () => {},
  handleCrearMateria = () => {},
  handleActualizarMateria = () => {},
  handleEliminarMateria = () => {},
  canUpdate = true,
  canDelete = true,
}) {
  const formNuevoId = "materias-form-nuevo";
  const formEditarId = "materias-form-editar";
  const isNuevoValido = formNuevo.nombre?.trim();
  const isEditarValido = formEditar.nombre?.trim();

  return (
    <>
      <ModalWrapper open={modal === "crear"} title="Nueva materia" onClose={cerrarModal} size="modal-lg">
        <div className="modal-body">
          <MateriasForm
            modo="crear"
            form={formNuevo}
            setForm={setFormNuevo}
            onSubmit={handleCrearMateria}
            loading={savingNuevo}
            formId={formNuevoId}
            showActions={false}
          />
        </div>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={savingNuevo}>
            Cancelar
          </button>
          <button
            type="submit"
            form={formNuevoId}
            className="btn management-btn-primary"
            disabled={savingNuevo || !isNuevoValido}
          >
            {savingNuevo ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Guardando...
              </>
            ) : (
              "Guardar"
            )}
          </button>
        </div>
      </ModalWrapper>

      <ModalWrapper open={modal === "editar" && canUpdate} title="Editar materia" onClose={cerrarModal} size="modal-lg">
        <div className="modal-body">
          {materiaSeleccionada && (
            <div className="border rounded bg-light p-3 mb-3">
              <p className="mb-1 fw-semibold">{materiaSeleccionada.nombre}</p>
              <p className="mb-0 text-muted small">
                Sigla: {materiaSeleccionada.sigla || "-"}
              </p>
            </div>
          )}
          <MateriasForm
            modo="editar"
            form={formEditar}
            setForm={setFormEditar}
            onSubmit={handleActualizarMateria}
            loading={savingEditar}
            formId={formEditarId}
            showActions={false}
          />
          {materiaSeleccionada?.id && (
            <div className="mt-3">
              <MateriaVideosManager materiaId={materiaSeleccionada.id} />
            </div>
          )}
        </div>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={savingEditar}>
            Cancelar
          </button>
          <button
            type="submit"
            form={formEditarId}
            className="btn management-btn-primary"
            disabled={savingEditar || !isEditarValido || !canUpdate}
          >
            {savingEditar ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Guardando...
              </>
            ) : (
              "Guardar"
            )}
          </button>
        </div>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "eliminar" && canDelete}
        title="Eliminar materia"
        onClose={cerrarModal}
        size="modal-md"
      >
        <div className="modal-body">
          <p className="mb-2">
            Estas a punto de eliminar la materia <strong>{materiaSeleccionada?.nombre || "seleccionada"}</strong>.
          </p>
          <p className="text-muted mb-0">
            Esta accion no se puede deshacer. Si la materia esta asignada en cursos, primero debes retirarla.
          </p>
        </div>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={deleting}>
            Cancelar
          </button>
          <button type="button" className="btn btn-danger" onClick={handleEliminarMateria} disabled={deleting || !canDelete}>
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Eliminando...
              </>
            ) : (
              "Eliminar"
            )}
          </button>
        </div>
      </ModalWrapper>
    </>
  );
}
